var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217.78 217.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_7",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 7"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M108.89,0C48.85,0,0,48.85,0,108.89s48.85,108.89,108.89,108.89,108.89-48.85,108.89-108.89S168.93,0,108.89,0ZM108.89,203.57c-52.21,0-94.68-42.48-94.68-94.68S56.68,14.21,108.89,14.21s94.68,42.48,94.68,94.68-42.47,94.68-94.68,94.68ZM139.38,51.78c-.52-.22-1.08-.33-1.64-.33-1.7,0-3.22,1.01-3.89,2.57-.44,1.04-.45,2.18-.02,3.23.42,1.04,1.23,1.86,2.26,2.3,11.22,4.74,20.06,14.01,24.28,25.42.61,1.65,2.2,2.76,3.96,2.76.5,0,1-.09,1.46-.26,2.18-.81,3.3-3.24,2.49-5.42-5.02-13.59-15.55-24.62-28.9-30.26ZM187.3,79.4c-7.41-21.17-23.52-38.33-44.2-47.08-.55-.23-1.12-.35-1.72-.35-1.78,0-3.37,1.06-4.06,2.69-.94,2.24.11,4.83,2.34,5.77,18.4,7.78,32.73,23.05,39.32,41.88.62,1.77,2.29,2.95,4.16,2.95.49,0,.98-.08,1.45-.25,1.11-.39,2-1.19,2.51-2.25.51-1.06.58-2.26.19-3.37ZM108.89,63.38c-25.13,0-45.51,20.38-45.51,45.51s20.38,45.51,45.51,45.51,45.51-20.38,45.51-45.51-20.38-45.51-45.51-45.51ZM108.89,116.91c-4.43,0-8.02-3.59-8.02-8.02s3.59-8.02,8.02-8.02,8.02,3.59,8.02,8.02-3.59,8.02-8.02,8.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundMaster);
export default __webpack_public_path__ + "static/media/SoundMaster.8e2578cdc8d0c2f28defd318d4174044.svg";
export { ForwardRef as ReactComponent };